module.exports = __webpack_public_path__ + "static/baska-interpolacija-v2-1338518c4c836b3273ece5c7b4e1e13d.jpg";